module.exports = __webpack_public_path__ + "img/bendishenghuo.99f7866a.png";